module.exports = __webpack_public_path__ + "img/icon_green.73188ce.png";